const displayStyles = (theme) => ({
  appearanceContainer: {
    display: 'inline-flex',
    alignItems: 'center',
    padding: '34',
    boxSizing: 'border-box'
  },
  appearanceText: {
    color: theme.HeaderSelectedText,
    fontSize: theme.headerTextFontSize16,
    fontWeight: 600,
    marginRight: 20,
    lineHeight: '120px'
  },
  appearanceGroupContainer: {
    display: 'flex',
    gap: '60px'
  },
  appearanceTitle: {
    fontSize: theme.HeaderSelectedText,
    fontWeight: 400,
    textAlign: 'center',
    textTransform: 'uppercase',
    color: theme.dispatchPanelLabelValueColor
  },
  appearanceOptions: {
    display: 'flex',
    justifyContent: 'center'
  },
  appearanceOption: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    margin: 16,
    cursor: 'pointer',
    borderRadius: 4,
    textAlign: 'center',
    border: `2px solid transparent`,
    transition: 'transform 0.3s ease',
    '&:hover': {
      transform: 'scale(1.1)'
    },
  },
  appearanceActive: {
    borderColor: theme.HeaderSelectedText,
    boxSizing: 'border-box',
  },
  appearanceName: {
    color: theme.TextColor,
    fontSize: theme.textFontSize,
    textAlign: 'center'
  }
});

const themesConfig = [
  {
    themeName: 'modernLight',
    themeCardLabel: 'Light',
    themeCardTitle: 'theme',
    colors: {
      mainBackgroundColor: '#0C6BB9',
      dividerColor: '#DFDFDF',
      accentLineColor: '#CCCCCC',
      backgroundFillColor: 'white',
      headerBarColor: '#17243C'
    }
  },
  {
    themeName: 'modernDark',
    themeCardLabel: 'Dark',
    themeCardTitle: 'theme',
    colors: {
      mainBackgroundColor: '#47A9F6',
      dividerColor: '#314059',
      accentLineColor: '#314059',
      backgroundFillColor: '#17243C',
      headerBarColor: '#17243C'
    }
  }
];

export { displayStyles, themesConfig };
